var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-row middle",staticStyle:{"background-color":"#fff"}},[_c('div',{staticClass:"flex-row start middle left",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"title-label"},[_vm._v(_vm._s(_vm.title))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }